import { Component, EventEmitter, Input, Output } from '@angular/core';

import { fullAutoTuningRunning } from '@app/models/status-resolve';
import { Device } from '@app/store/device.model';

@Component({
  selector: 'app-full-auto-tuning-button',
  templateUrl: './full-auto-tuning-button.component.html',
})
export class FullAutoTuningButtonComponent {
  @Input() device: Device;

  @Output() startFullAutoTuning = new EventEmitter<void>();
  @Output() stopFullAutoTuning = new EventEmitter<void>();

  get isFullAutoTuningRunning() {
    return fullAutoTuningRunning(this.device.fullAutoTuningStatus);
  }
}
